import React, { useState } from 'react'

import * as yup from 'yup';
import { useToast } from '../../../../Components/Others/ToastServices';
import { useFormik } from 'formik';
import axiosInstance from '../../../../Services/axiosCommon';
import { NuUpload } from '../../../../Components/Utils/Input';

const ImportSupportTicket = ({ show, onClose, getData }) => {
    const [isLoading, setIsLoading] = useState(false);
    const toast = useToast();
    const [file, setFile] = useState(null);
   
    const formik = useFormik({
      initialValues: {},
      validationSchema: yup.object({}),
      onSubmit: async (values, { resetForm }) => {
        setIsLoading(true);
        let formData = new FormData();
        console.log("sss",file);
        if (file) {
          formData.append('file', file);
        }
        await axiosInstance.post(`/employees/import`,formData)
        .then(res => {               
          if (res.data) {
              console.log("Created", resetForm)
              resetForm();
              onClose();
              getData();
              toast.open({
                type:"success",
                message: `Imported File Added successfully`,
                
            });
          }
          else {
              setIsLoading(false);
              console.log("Failed")
              toast.open({
                type:"error",
                message: `Imported File Added failed`,
                
            });
          }
      }
      ).catch(err=>{
        setIsLoading(false);
        console.log("Failed")
        toast.open({
          type:"error",
          message: `Imported File Added failed`,
         
      });
      })
    } 
    });
  
    const handleFileChange = (e) => {
      if (e.target.files.length) {
        setFile(e.target.files[0]);
      }
    };
  
    if (!show) return null;
  
    return (
      <>
      
          <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
            <div className="animate-scale-in min-w-[90%] sm:min-w-[40%] max-w-[70%] max-h-[80vh] bg-white py-6 px-6 rounded-md shadow-lg overflow-y-scroll">
              <form onSubmit={formik.handleSubmit}>
                <div className="w-full">
                <NuUpload
                label="Import"
                width="w-full "
                onChange={handleFileChange}
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,text/comma-separated-values, text/csv, application/csv"
              /> 
              <div className='flex gap-4 justify-center items-baseline'>
                  <button
                    type="submit"
                    className={ `px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm  rounded-lg mt-4 text-center ${isLoading ? 'bg-red-300 cursor-wait' : 'bg-baseColor-primary'} text-white`}
                    disabled={isLoading}
                  >
                    {isLoading === true ? 'Importing...' : 'Import'}
                  </button>
                  <button
    type="button"
    onClick={() => { console.log("Cancel button clicked"); onClose(); }}
    className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm  text-textColor-main bg-[#E6F2F2] hover:bg-gray-300
        rounded-md flex items-center`"
  >
    Cancel
  </button>  </div>
                </div>
              </form>
            </div>
          </div>
       
      </>
    );
  };
  

export default ImportSupportTicket